import { render } from "./Billing.vue?vue&type=template&id=2f4c570c&scoped=true"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"

import "./Billing.vue?vue&type=style&index=0&id=2f4c570c&lang=scss&scoped=true"
import "./Billing.vue?vue&type=style&index=1&id=2f4c570c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4c570c"]])

export default __exports__